<template>
  <picker-field :label="label" :value="value" :is-focus="isFocus" :isNeedInput="isNeedInput" title="选择产品" @onchange="onchange" ref="picker" @open="onSearch">
    <template v-slot:tbar>
      <search-bar
        @search="onSearch"
        @focus="onFocusChange"
        name="pr_code,pr_orispeccode,pr_detail,pr_spec"
        placeholder="输入产品编号、名称、型号、规则进行查找"
        ref="searchBar"
      />
    </template>
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        @click="select(item)"
      >
        <div class="weui-cell__bd">
          <p>{{item.pr_detail}}</p>
          <p class="list-item-muted">{{item.pr_orispeccode}} {{item.pr_spec}}</p>
        </div>
        <div class="weui-cell__ft">{{item.pr_code}}</div>
      </div>
    </scroll-list>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import querylist from "@/mixins/querylist.js";

export default {
  components: {
    PickerField,
    SearchBar,
    ScrollList
  },
  mixins: [querylist],
  props: {
    label: {
      type: String,
      default: "产品名称"
    },
    value: String,
    isNeedInput: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isFocus: false,
      listUrl: "/api/document/product/list",
      defaultCondition: {
        field: "pr_statuscode",
        operation: "=",
        value: "ENABLE"
      }
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.pr_detail);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onchange(value) {
      var me = this
      me.$emit("onchange", value);
    },
    onFocusChange(focus) {
      this.isFocus = focus;
    }
  }
};
</script>